import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ListChecks } from 'lucide-react';
import { generalWaMessage } from './servicesData';
import ServiceRequestModal from './ServiceRequestModal';
import useWhatsApp from '@/lib/useWhatsApp';

export default function ServicesHero({ autoOpenProject }) {
  const [showModal, setShowModal] = useState(false);
  const { waLink, t } = useWhatsApp();

  useEffect(() => {
    if (autoOpenProject) setShowModal(true);
  }, [autoOpenProject]);

  return (
    <section className="relative pt-40 pb-24 px-6 overflow-hidden">
      <div className="max-w-5xl mx-auto text-center relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}>
          <span className="text-xs font-inter font-medium tracking-[0.3em] uppercase text-primary mb-4 block">
            {t('What We Build')}
          </span>
          <h1 className="font-inter font-black text-5xl md:text-7xl tracking-[-0.03em] text-foreground mb-6 leading-[1.05]">
            {t('Digital Services for Businesses in Dubai & the UAE')}
          </h1>
          <p className="text-lg text-muted-foreground font-inter leading-relaxed max-w-2xl mx-auto mb-10">
            {t('From our base in Dubai Silicon Oasis, Jotunheims engineers complete digital solutions for businesses across Dubai and the wider UAE: websites, landing pages, SaaS platforms, mobile apps, games, custom AI, business automation, digital marketing and AI-powered cybersecurity, from concept to launch.')}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href={waLink(generalWaMessage)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground font-inter font-semibold text-sm tracking-wider uppercase rounded-xl hover:bg-primary/90 transition-all duration-300 hover:shadow-lg hover:shadow-primary/25">
              <MessageCircle className="w-4 h-4" />
              {t('Talk to Us on WhatsApp')}
            </a>
            <button
              type="button"
              onClick={() => setShowModal(true)}
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground font-inter font-semibold text-sm tracking-wider uppercase rounded-xl hover:bg-primary/90 transition-all duration-300 hover:shadow-lg hover:shadow-primary/25">
              <ListChecks className="w-4 h-4" />
              {t('Send Your Project in 3 Steps')}
            </button>
          </div>
        </motion.div>
      </div>

      {showModal && <ServiceRequestModal onClose={() => setShowModal(false)} />}
    </section>);

}